<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <b-form class="mt-4" v-if="compraLinea === true" v-on:submit.prevent="guardarDatosPortal">
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <b-card title="Información de usuario">
                  <b-form-group>
                    <div>
                      <strong>Token acceso: </strong>
                      <span class="text-danger" style="text-transform: none !important;">{{
                          portalLinea.tokenAcceso ? portalLinea.tokenAcceso : 'No se ha guardado el portal'
                        }}</span>
                    </div>
                  </b-form-group>
                  <b-form-group
                      label="Nombre de usuario">
                    <b-form-input
                        placeholder="Nombre de usuario"
                        v-model="portalLinea.usuario"
                        :state="portalLinea.usuario != null"
                        required
                    />
                    <b-form-invalid-feedback :state="portalLinea.usuario != null">
                      El campo es requerido
                    </b-form-invalid-feedback>
                    <b-form-checkbox
                        v-model="cambiarContrasenia">
                      Cambiar contraseña
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group label="Contraseña" v-if="cambiarContrasenia">
                    <b-form-input
                        type="password"
                        v-model="portalLinea.contrasenia"
                        :state="portalLinea.contrasenia != null"
                        required
                    >
                    </b-form-input>
                    <b-form-invalid-feedback
                        :state="portalLinea.contrasenia != null"
                    >
                      El campo es requerido
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                      label="Imagen corporativa:"
                      description="Debe escoger una imagen .png, maximo de dimensiones 200 x 150px"
                  >
                    <b-form-file
                        placeholder="Seleccionar imagen *"
                        accept=".png"
                        browse-text="Abrir"
                        v-on:change="seleccionarArchivo"
                        ref="inputFile"
                    ></b-form-file>
                  </b-form-group>
                  <b-form-group class="text-center">
                    <label>Solicitar Cambio de Contraseña (control acceso)</label>
                    <b-form-checkbox
                        v-model="portalLinea.solicitarConstrasenia"
                        switches
                    ></b-form-checkbox>
                  </b-form-group>
                  <b-card v-if="portalLinea.solicitarConstrasenia">
                    <b-form-group label="Correo">
                      <b-form-input
                          placeholder="correo"
                          v-model="portalLinea.correo"
                          :state="portalLinea.correo != null"
                          required
                      />
                      <b-form-invalid-feedback :state="portalLinea.correo != null && portalLinea.solicitarConstrasenia">
                        El campo es requerido
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-card>
                  <b-form-group class="text-center">
                    <label>Logeo por token</label>
                    <b-form-checkbox
                        v-model="portalLinea.logeoPorToken"
                        switches
                    ></b-form-checkbox>
                  </b-form-group>
                </b-card>
              </b-col>
              <b-col>
                <b-card title="Información de campaña">
                  <b-form-group label="Inicio de campaña">
                    <b-form-datepicker
                        v-model="portalLinea.fechaInicio"
                        placeholder="Selecciona una fecha"
                        :state="portalLinea.fechaInicio != null"
                    >
                    </b-form-datepicker>
                    <b-form-invalid-feedback :state="portalLinea.fechaInicio != null">
                      El campo es requerido
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Fin de campaña">
                    <b-form-datepicker
                        v-model="portalLinea.fechaFin"
                        placeholder="Selecciona una fecha"
                        :state="portalLinea.fechaFin != null"
                    >
                    </b-form-datepicker>
                    <b-form-invalid-feedback :state="portalLinea.fechaFin != null">
                      El campo es requerido
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-card>

              </b-col>
              <b-col>
                <b-card title="Información de pagos">
                  <b-form-group label="Pagos diferidos">
                    <b-form-checkbox-group
                        :options="listaPortalMsi.map(msi => ({text: msi.descripcion, value: msi.idPortalMsi}))"
                        v-model="portalLinea.portalMsi"
                        switches
                        stacked
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-card class="mt-3 mb-3" title="Personalizar portal" sub-title-text-variant="center"
                v-if="portalLinea.idEmpresaPortal !== null">
          <b-row>
            <b-col>
              <div class="jumbotron">
                <b-row>
                  <b-col cols="3" v-for="color in getColoresPortal" :key="color.nombre">
                    <v-swatches
                        v-model="color.color"
                        class="float-left"
                        show-fallback
                        fallback-input-type="color"
                        popover-x="left"
                    ></v-swatches>
                    <span class="float-left mt-2 ml-1" style="font-size: 14px">{{
                        color.nombre
                      }}</span>
                  </b-col>
                </b-row>
              </div>

            </b-col>

          </b-row>
        </b-card>

        <b-button class="mt-4" variant="primary" v-if="enviandoPortal" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>

        <div v-else>
          <b-button-group>
            <b-button type="submit" variant="outline-primary">
              Guardar
            </b-button>
            <b-button v-b-modal:ver-portal variant="outline-info">Previsualizar</b-button>
            <b-button
                variant="outline-warning"
                v-on:click="inactivarPortalLinea"
                v-if="portalLinea.idEmpresaPortal != null"
            >
              Inactivar
            </b-button>
          </b-button-group>


          <b-modal
              modal-class="w100"
              hide-footer
              size="xl"
              cancel-title="Cerrrar"
              id="ver-portal">

            <iframe style="width: 100%; height: 800px"
                    :src="getUrl()"></iframe>
          </b-modal>
        </div>
      </b-form>
      <b-form-checkbox
          v-model="compraLinea"
          v-else
      >
        ¿Permitir comprar en linea?
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import VSwatches from "vue-swatches";

export default {
  name: "PortalLineaEmpresas",
  props: {
    idEmpresa: {
      type: Number,
      require: true,
    },
  },
  components: {
    VSwatches,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listaPortalMsi: [],
    portalLinea: {
      idEmpresaPortal: null,
      idImagen: null,
      usuario: null,
      contrasenia: null,
      tokenAcceso: null,
      fechaInicio: null,
      fechaFin: null,
      portalMsi: [],
      colores: [],
      solicitarConstrasenia:false,
      correo:null
    },
    cambiarContrasenia: false,
    compraLinea: false,
    cargandoPortalcom: true,
    enviandoPortal: null
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.idEmpresa != null) {
      this.traerPortalMSI();
      this.traerDatosPortalLinea();
    } else {
      this.cargandoPortalcom = false;
    }
  },
  computed: {
    getColoresPortal() {
      return this.portalLinea.colores;
    }
  },
  methods: {
    getUrl() {
      return process.env.VUE_APP_FRONT_PORTAL_COMERCIAL_BASE_URL + 'token/tema/' + this.portalLinea.tokenAcceso
    },
    traerPortalMSI() {
      const url = this.$api + "catalogos/listaPortalMsi";
      this.$http.get(url).then((response) => {
        if (response.data.data) {
          this.listaPortalMsi = response.data.data;
        }
      });
    },
    traerDatosPortalLinea() {
      this.cargandoPortalcom = true;
      const parametros = {idEmpresa: this.idEmpresa}
      const url = this.$api + "empresas/traerPortal/linea";
      this.$http
          .post(url, parametros)
          .then((response) => {
            if (response.data.data) {
              this.portalLinea = response.data.data;
              if (response.data.data.idEmpresaPortal != null) {
                this.compraLinea = true;
              }
              if (this.portalLinea.colores) {
                this.portalLinea.colores = response.data.data.catalogoElementos.map(elemento => {
                  const existe = this.portalLinea.colores.find(color => elemento.idElemento === color.idElemento);
                  if (existe) return existe;
                  elemento.color = '#FFFFFF';
                  return elemento;
                });
              }

            }
          })
          .catch((err) => {
            console.error(err.message)
          })
          .finally(() => {
            this.cargandoPortalcom = false;
          });
    },
    seleccionarArchivo(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        console.error("no files");
      } else {
        const file = new Blob([files[0]], {type: "image/png"});
          if(files[0].type.split("/")[1] !== 'png'){
              this.$swal({
                icon: "error",
                title: "La imagen debe ser png",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
                 this.$refs.inputFile.reset();
            }
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new Image();
          img.src = evt.target.result;
          img.onload = () => {
            if (img.width > 200 || img.height > 150) {
              this.$swal({
                icon: "error",
                title: "La imagen excede del tamaño 200px y 150px",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
              this.$refs.inputFile.reset();
              return false;
            }
              const name = e.target.files[0].name;
              const lastDot = name.lastIndexOf(".");
              const fileName = name.substring(0, lastDot);
              const ext = name.substring(lastDot + 1);

              const formData = new FormData();
              formData.append("imagenBase", file, fileName);
              formData.append(
                  "usuarioLogeado",
                  this.$localStorageService.getIdUsuario()
              );
              formData.append("nombre", fileName);
              formData.append("ext", ext);

              this.enviarImagen(formData);
            }
        };

        reader.onerror = (evt) => {
          console.error(evt);
        };
      }
    },
    enviarImagen(formData) {
      const url = this.$api + "empresas/imagen";
      let config = {
        header: {
          "Content-Type": "image/png",
        },
      };

      this.$http.post(url, formData, config).then((response) => {
        if (response.data.data) {
          this.portalLinea.idImagen = response.data.data;
        }
      });
    },
    validarDatosPortal() {
      let error = false;
      if (
          this.portalLinea.fechaInicio == null ||
          this.portalLinea.fechaFin == null ||
          this.portalLinea.portalMsi.length == 0
      ) {
        error = true;
        this.$swal({
          icon: "error",
          text: "Debe completar todos los campos",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      }
      return error;
    },
    guardarDatosPortal() {
      if (!this.validarDatosPortal()) {
        this.enviandoPortal = true;

        const url = this.$api + "empresas/portal/linea";

        this.$http
            .post(url, this.traerDatos())
            .then((response) => {
              if (response.status === 200) {
                this.mensajeFinalRegistro();
                this.traerDatosPortalLinea();
              }
            })
            .catch(error => {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: error.response.data.message,
              });
            })
            .finally(() => {
              this.enviandoPortal = false;
            });
      }
    },
    inactivarPortalLinea() {
      this.enviandoPortal = true;
      const url = this.$api + "empresas/portal/linea";

      this.$http
          .post(url, this.traerDatos())
          .then((response) => {
            if (response.status === 200) {
              this.mensajeFinalRegistro();
              this.traerDatosPortalLinea();
            }
          })
          .catch(error => {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: error.response.data.message,
            });
          })
          .finally(() => {
            this.enviandoPortal = false;

            this.portalLinea.idEmpresaPortal = null;
            this.portalLinea.idImagen = null;
            this.portalLinea.usuario = null;
            this.portalLinea.contrasenia = null;
            this.portalLinea.tokenAcceso = null;
            this.portalLinea.fechaInicio = null;
            this.portalLinea.fechaFin = null;
          });
    },
    mensajeFinalRegistro() {
      this.$swal({
        icon: "success",
        text: "Se registró correctamente",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
        onClose: () => {
          this.traerDatosPortalLinea();
          this.cambiarContrasenia = false;
        },
      });
    },
    traerDatos() {
      return {
        idEmpresaPortal: this.portalLinea.idEmpresaPortal,
        idEmpresa: this.idEmpresa,
        idImagen: this.portalLinea.idImagen,
        usuario: this.portalLinea.usuario,
        contrasenia: this.portalLinea.contrasenia,
        fechaInicio: this.$global.traerFecha(this.portalLinea.fechaInicio),
        fechaFin: this.$global.traerFecha(this.portalLinea.fechaFin),
        portalMsi: this.portalLinea.portalMsi,
        colores: this.portalLinea.colores,
        usuarioLogueado: this.$localStorageService.getIdUsuario(),
        cambiarContrasenia: this.cambiarContrasenia,
        solicitarConstrasenia: this.portalLinea.solicitarConstrasenia,
        correo: this.portalLinea.correo,
        idUsuario: this.portalLinea.idUsuario,
        logeoPorToken: this.portalLinea.logeoPorToken
      };
    },
  },
  notifications: {
    errorTraerDatos: {
      type: "error",
      title: "Error",
      message: "Error al traer los datos",
    },
    errorEnviarDatos: {
      type: "error",
      title: "Error",
      message: "Error al enviar los datos",
    },
  },
};
</script>

<style>
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 90% !important;
  }
}

.modal-xl {
  max-width: 90% !important;
}
</style>
